/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}#file-container[_ngcontent-%COMP%], #main-container[_ngcontent-%COMP%]{height:100%;width:100%}"];
export { styles as styles };
